<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <component
          v-bind:is="currentComponent"
          @restore-password="currentComponent = 'restore-form'"
          @login-form="currentComponent = 'login-form'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoginForm from "../components/LoginForm";
import RestoreForm from "../components/RestoreForm";

export default {
  name: "LoginPage",
  components: {
    LoginForm,
    RestoreForm
  },
  data() {
    return {
      currentComponent: LoginForm
    };
  }
};
</script>

<style></style>
